class Wishlist {
  constructor() {
    this.isWishlistPage = false;
    this.storageKey = "m-wishlist-products";
    this.products = [];
    this.productNodes = {};

    this.pageTemplate = "page.wishlist";
    this.addedClass = "added-to-wishlist";
    this.hasItemClass = "wishlist-has-item";
    this.selectors = {
      container: ".m-wishlist-page-content__wrapper",
      noProducts: ".m-wishlist-no-products",
      wrapper: ".m-wishlist-card",
      productCard: ".m-product-card",
      wishlistButton: ".m-wishlist-button",
      wishlistText: ".m-wishlist-button-text",
      removeButton: ".m-wishlist-remove-button",
      count: ".m-wishlist-count",
      invoiceButton: ".m-wishlist-invoice-button",
      invoiceButtonRow: ".m-wishlist-invoice-button-row",
    };
    this.products = Array.from(
      new Set(
        Array.from(JSON.parse(localStorage.getItem(this.storageKey)) || [])
      )
    );
    this.orderArray = [];
    this.isWishlistPage = MinimogSettings.template === this.pageTemplate;
    this.init();
  }

  init = async () => {
    if (this.isWishlistPage) {
      await this.renderWishlistPage();
      this.addEventToRemoveButtons(); // Add this new line
      this.addEventToInvoiceButton(); // Add this new line
    }
    this.setWishlistButtonsState();
    this.addEventToWishlistButtons();
    this.updateWishlistCount();
  };

  saveToStorage = () => {
    this.products = Array.from(new Set(this.products));
    localStorage.setItem(this.storageKey, JSON.stringify(this.products));
  };

  addToWishlist(handle) {
    if (handle && this.products.indexOf(handle) === -1) {
      this.products.push(handle);
      this.saveToStorage();
    }
  }

  removeFromWishlist(handle) {
    this.products = this.products.filter((hdl) => hdl !== handle);
    this.saveToStorage();
  }

  // addInvoiceButton = () => {
  //   // Get the URL parameters
  //   const urlParams = new URLSearchParams(window.location.search);
  //   const isNdis = urlParams.get("ndis") === "t";

  //   const invoiceButtonRow = document.querySelector(
  //     this.selectors.invoiceButtonRow
  //   );
  //   if (invoiceButtonRow && isNdis) {
  //     const invoiceButton = document.createElement("button");
  //     invoiceButton.classList.add(
  //       "m-wishlist-invoice-button",
  //       "m-button",
  //       "m-button--primary"
  //     );
  //     invoiceButton.textContent = "Create an NDIS Invoice";
  //     invoiceButtonRow.appendChild(invoiceButton);
  //   }
  // };

  addEventToInvoiceButton = async () => {
    const shopifyAnalytics = getCookie("_shopify_sa_p");
    const decodedValue = decodeURIComponent(shopifyAnalytics);
    const utmParams = new URLSearchParams(decodedValue);
    // Get individual UTM values
    const utmSource = utmParams.get("utm_source"); // "email"
    const utmMedium = utmParams.get("utm_medium"); // "campaign"
    const utmCampaign = utmParams.get("utm_campaign");

    const invoiceButton = document.querySelector(this.selectors.invoiceButton);
    if (invoiceButton) {
      invoiceButton.addEventListener("click", async () => {
        const toolsAndTrainingCollection = await fetch(
          `/collections/tools-training/products.json?limit=100`
          );
          const toolsAndTrainingCollectionData = await toolsAndTrainingCollection.json(); 
        
        let productsWithLineBreaks = "";
        let notQualifiedForNdisProductsWithLineBreaks = "";

        for (let i = 0; i < this.orderArray.length; i++) {
          const title = this.orderArray[i];
          const productTitle = title.split(" $")[0];

          if (toolsAndTrainingCollectionData.products.some((product) => product.title === productTitle)) {
            const titleEncoded = encodeURIComponent(title);
            const lineBreakString = `${titleEncoded} %7C Quantity : 1 %0A`;
            productsWithLineBreaks += lineBreakString;
          } else {
            const titleEncoded = encodeURIComponent(productTitle);
            const lineBreakString = `${titleEncoded} %0A`;
            notQualifiedForNdisProductsWithLineBreaks += lineBreakString;
          }
        }

        const productHandles = this.products
          .filter((hdl) => {
            return toolsAndTrainingCollectionData.products.some((product) => product.handle === hdl);
          })
          .map((hdl) => {
            return `${hdl},`;
          })
          .join("");

          const utmParams = [];
          if (utmSource) utmParams.push(`s=${encodeURIComponent(utmSource)}`);
          if (utmMedium) utmParams.push(`m=${encodeURIComponent(utmMedium)}`);
          if (utmCampaign) utmParams.push(`c=${encodeURIComponent(utmCampaign)}`);
          
          const utmString = utmParams.length > 0 ? `&${utmParams.join('&')}` : '';

        window.open(
          `https://forms.zohopublic.com.au/theplayway/form/InvoicefromTPWWishlist/formperma/MDQIKKbsCGjua3naFqdlJY0iKq-IZncqbamhdCUSwfQ?draft_order=${productsWithLineBreaks}&products=${productHandles}&removed=${notQualifiedForNdisProductsWithLineBreaks}${utmString}`,
          "_blank"
        );
      });
    }
  };

  setWishlistButtonsState = () => {
    const buttons = document.querySelectorAll(this.selectors.wishlistButton);
    buttons.forEach((btn) => {
      const prodHandle = btn && btn.dataset.productHandle;
      if (
        this.products.indexOf(prodHandle) >= 0 &&
        btn &&
        !btn.classList.contains(this.addedClass)
      ) {
        this.toggleButtonState(btn, true);

        if (this.isWishlistPage) {
          btn.classList.remove(this.selectors.wishlistButton.replace(".", ""));
          btn.classList.add(this.selectors.removeButton.replace(".", ""));
        }
      }
    });
  };

  updateWishlistCount = () => {
    const size = this.products.length;
    const countElems = document.querySelectorAll(this.selectors.count);
    [...countElems].forEach((elem) => {
      elem.textContent = size;
      if (size < 1) {
        elem.classList.add("m:hidden");
      } else {
        elem.classList.remove("m:hidden");
      }
    });
    const method = size ? "add" : "remove";
    document.body.classList[method](this.hasItemClass);
  };

  addEventToWishlistButtons = () => {
    addEventDelegate({
      selector: this.selectors.wishlistButton,
      handler: (e, btn) => {
        e.preventDefault();
        const productHandle = btn && btn.dataset.productHandle;
        if (productHandle) {
          const active = !btn.classList.contains(this.addedClass);
          this.toggleButtonState(btn, active);
          this.updateWishlistCount();

          document
            .querySelectorAll(this.selectors.wishlistButton)
            .forEach((btnItem) => {
              if (
                btnItem &&
                btnItem.dataset.productHandle === productHandle &&
                btnItem !== btn
              ) {
                const isAdded = !btnItem.classList.contains(this.addedClass);
                this.toggleButtonState(btnItem, isAdded);
              }
            });
        }
      },
    });
  };

  toggleButtonState = (btn, active) => {
    const productHandle = btn && btn.dataset.productHandle;
    const wishlistText = btn && btn.querySelector(this.selectors.wishlistText);

    if (active) {
      this.addToWishlist(productHandle);
      btn.classList.add(this.addedClass);
    } else {
      this.removeFromWishlist(productHandle);
      btn.classList.remove(this.addedClass);
    }

    if (wishlistText) {
      const temp = wishlistText.dataset.revertText;
      wishlistText.dataset.revertText = wishlistText.textContent;
      wishlistText.textContent = temp;
    }
  };

  addEventToRemoveButtons = () => {
    addEventDelegate({
      selector: this.selectors.removeButton,
      handler: (e, btn) => {
        e.preventDefault();
        const prod = btn && btn.closest(this.selectors.wrapper);
        prod && prod.remove();

        const productHandle = btn && btn.dataset.productHandle;
        if (productHandle) {
          this.removeFromWishlist(productHandle);
          this.updateWishlistCount();
          if (!this.products.length) {
            this.showNoProductsMessage();
          }
        }
      },
    });
  };

  wishlistRemoveButton(prdHandle) {
    const html = `<svg class="m-svg-icon--medium" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>`;
    const button = document.createElement("DIV");
    button.classList.add(
      "m-tooltip",
      "m-wishlist-remove-button",
      "m:block",
      "md:m:hidden"
    );
    button.setAttribute("data-product-handle", prdHandle);
    button.innerHTML = html;
    return button;
  }

  renderWishlistPage = async () => {
    const container = document.querySelector(this.selectors.container);
    if (container) {
      let noItemAvailable = true;
      if (this.products.length) {
        const promises = this.products.map(async (hdl) => {
          const url = formatUrl("products", hdl, "view=grid-card-item");
          const prodHTML = await fetchCache(url);
          const parser = new DOMParser();
          const doc = parser.parseFromString(prodHTML, "text/html");
          const name = doc.getElementsByClassName("m-product-card__name")[0];
          const price = doc.getElementsByClassName(
            "m-price-item m-price-item--regular"
          )[0];
          this.orderArray.push(
            name.textContent.trim() + " " + price.textContent.trim()
          );
          const item = document.createElement("DIV");
          item.classList.add("m:hidden", "m:column", "m-wishlist-card");
          item.innerHTML = prodHTML;
          if (item.querySelector(this.selectors.productCard)) {
            noItemAvailable = false;
            item.appendChild(this.wishlistRemoveButton(hdl));
            this.productNodes[hdl] = item;
          }
        });

        await Promise.all(promises);

        // Render in order
        this.products.forEach((hdl) => {
          const prod = this.productNodes[hdl];
          if (prod) {
            container.appendChild(prod);

            if (MinimogTheme.CompareProduct) {
              MinimogTheme.CompareProduct.setCompareButtonsState();
            }

            prod.classList.remove("m:hidden");
          }
        });
        // this.addInvoiceButton(container);
      }

      if (noItemAvailable) {
        this.showNoProductsMessage();
      } else {
        this.setWishlistButtonsState();
      }

      container.classList.add("is-visible");
    }
  };

  showNoProductsMessage = () => {
    const container = document.querySelector(this.selectors.container);
    const noProducts = document.querySelector(this.selectors.noProducts);

    container.classList.add("m:hidden");
    noProducts.classList.remove("m:hidden");
  };
}

MinimogTheme.Wishlist = new Wishlist();
